import React from "react";
import Modal from "@material-ui/core/Modal";

import { Button, StyledGrid } from "components/simple";
import { color } from "style/constants";
import { ReactComponent as Warning } from "assets/warning-red.svg";
import styled from "styled-components";

export const Header = styled.h1`
  color: ${color.BLACK};
  font-family: Mercury Display, mercury-display, sans-serif;
  font-size: "1.5rem";
  line-height: 29px;
  letter-spacing: -0.36px;
`;

export const Paragraph = styled.p`
  color: ${color.DARKERGRAY};
  font-size: ".875rem";
  white-space: pre-wrap;
`;

interface ModalProps {
  openModal: boolean;
  onClose: () => void;
  callback: () => void;
  user: string;
}

const ResetPasswordModal: React.FC<ModalProps> = ({
  openModal,
  onClose,
  callback,
  user
}: ModalProps): JSX.Element => {
  return (
    <Modal
      aria-labelledby="reset-password"
      aria-describedby="simple-modal-description"
      open={openModal}
      onClose={onClose}
    >
      <StyledGrid
        absoluteCenter
        backgroundColor={color.BLACK_RGBA}
        container
        centerContent
        height={"100%"}
        width={"100%"}
        style={{ zIndex: 1100 }}
        position="fixed"
      >
        <StyledGrid
          absoluteCenter
          backgroundColor={color.WHITE}
          borderRadius={"8px"}
          boxShadow={"0px 4px 14px rgba(223, 223, 223, 0.85);"}
          centerContent
          container
          direction={"column"}
          item
          padding={"1em"}
          width={"100%"}
          maxWidth={"550px"}
        >
          <StyledGrid item marginBottom={"-3.5em"}>
            <Warning width={"150px"} height={"150px"} />
          </StyledGrid>
          <StyledGrid
            item
            width={"100%"}
            maxWidth={"450px"}
            marginTop={"1.5em"}
            marginBottom={"-1em"}
          >
            <Header>Caution!</Header>
          </StyledGrid>
          <StyledGrid container justifyContent={"center"} width={"100%"} maxWidth={"450px"}>
            <Paragraph>
              You are about to reset password for {user}.<br />
              Do you wish to proceed?
            </Paragraph>
          </StyledGrid>
          <StyledGrid
            container
            justifyContent={"center"}
            spacing={2}
            padding={"1rem 0"}
            maxWidth={"450px"}
          >
            <StyledGrid item>
              <Button inverted onClick={onClose}>
                No
              </Button>
            </StyledGrid>
            <StyledGrid item>
              <Button
                onClick={() => {
                  callback();
                }}
              >
                Yes
              </Button>
            </StyledGrid>
          </StyledGrid>
        </StyledGrid>
      </StyledGrid>
    </Modal>
  );
};

export default ResetPasswordModal;
